



















































































































































































import { Component, Vue } from 'vue-property-decorator'
import { EventBus } from '@/utils/event-bus'
import { Product } from '@/store/modules/product'
import ChooseGvdModal from './ChooseGvd.modal.vue'
import ChooseSlideDeckModal from './ChooseSlideDeck.modal.vue'
import ChooseWebApp from './ChooseWebApp.modal.vue'
import WebAppModal from '@/views/products/web-apps/web-app.modal.vue'
import { Resource } from '@/store/modules/resource'

@Component({
  components: {
    ChooseGvdModal,
    ChooseSlideDeckModal,
    WebAppModal,
    ChooseWebApp
  }
})
export default class MainNav extends Vue {
  products: Product[] = [];
  selectedProduct: Product = {} as Product;
  expandedProductKey: string | null = null;

  toggleProductExpand (productKey: string, event: Event) {
    event.stopPropagation()
    event.preventDefault()
    this.expandedProductKey = this.expandedProductKey === productKey ? null : productKey

    // Re-equalize widths after DOM updates
    this.$nextTick(() => {
      requestAnimationFrame(() => {
        const dropdownMenu = (event.target as HTMLElement)?.closest('.dropdown-menu')
        if (dropdownMenu) {
          this.equalizeDropdownWidths(dropdownMenu as HTMLElement)
        }
      })
    })
  }

  isProductExpanded (productKey: string) {
    return this.expandedProductKey === productKey
  }

  onDropdownShown (franchise: string) {
    const refKey = `dropdown-${franchise}`
    const refValue = this.$refs[refKey] as any
    // Refs in v-for return arrays
    const dropdownComponent = Array.isArray(refValue) ? refValue[0] : refValue
    const dropdownEl = dropdownComponent?.$el
    const dropdownMenu = dropdownEl?.querySelector('.dropdown-menu')

    if (dropdownMenu) {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.equalizeDropdownWidths(dropdownMenu)
        })
      })
    }
  }

  equalizeDropdownWidths (dropdownMenu: HTMLElement) {
    const items = dropdownMenu.querySelectorAll<HTMLElement>('.dropdown-item')
    if (!items.length) return

    // Reset widths first to get natural sizes
    items.forEach(item => {
      item.style.width = 'auto'
    })

    // Find the widest item
    let maxWidth = 0
    items.forEach(item => {
      const width = item.getBoundingClientRect().width
      if (width > maxWidth) {
        maxWidth = width
      }
    })

    // Apply the max width to all items
    items.forEach(item => {
      item.style.width = `${maxWidth}px`
    })
  }

  get isAuthenticated () {
    return this.$store.getters.isAuthenticated
  }

  get showAdmin () {
    return this.$store.getters.getUserPermissions.includes('admin.view')
  }

  get isInProduct () {
    const routesToMatch = ['product', 'gvd', 'summary-slides', 'resources']
    return routesToMatch.includes(this.$route.name || '')
  }

  async openWebAppModal (apps: Resource[], product: Product) {
    if (apps && apps.length === 1) {
      await this.$store.dispatch('setAppToken', apps[0].appToken)
      if (product) {
        await this.$store.dispatch('setAppProduct', product.key)
      }
      this.$bvModal.show('web-app-modal')
    } else if (apps && apps.length > 1) {
      await this.$store.dispatch('setAppProduct', product.key)
      this.selectedProduct = product
      this.$bvModal.show('choose-web-app-modal')
    } else {
      console.warn('No web apps available for this product.')
    }
  }

  getFranchises () {
    return [...new Set(this.products.map((p: Product) => p.productGroup.name))]
  }

  productsByFranchise (productGroup: string) {
    return this.products.filter(
      (p: Product) => p.productGroup.name === productGroup
    )
  }

  goToGvd (product: Product) {
    if (product.gvds.length === 1) {
      this.$router
        .push({
          name: 'gvd',
          params: { productKey: product.key, gvdKey: product.gvds[0].key }
        })
        .catch(() => {})

      return
    }

    this.selectedProduct = product
    this.$bvModal.show('choose-gvd-modal')
  }

  getButtonBackground () {
    if (this.isInProduct) {
      return this.$store.getters.getBGStyle3
    }
  }

  goToSlideDeck (product: Product) {
    if (product.slideDecks.length === 1) {
      this.$router
        .push({
          name: 'summary-slides',
          params: {
            productKey: product.key,
            slideDeckKey: product.slideDecks[0].key
          }
        })
        .catch(() => {})
      return
    }

    this.selectedProduct = product
    this.$bvModal.show('choose-slide-deck-modal')
  }

  goToProduct (product: Product) {
    this.$router
      .push({ name: 'product', params: { productKey: product.key } })
      .catch(() => {})
  }

  noProductAssets (product: Product) {
    return (
      !this.hasResources(product.key) &&
      !product.gvds.length &&
      !product.slideDecks.length
    )
  }

  hasResources (productKey: string) {
    return this.$store.getters.getResourcesForProductKey(productKey).length
  }

  webAppsForProduct (productKey: string) {
    return this.$store.getters.getWebAppsForProductKey(productKey)
  }

  isActiveProduct (key: string) {
    const routesToMatch = ['product', 'gvd', 'summary-slides', 'resources']
    return (
      routesToMatch.includes(this.$route.name || '') &&
      (this.$route.params.productKey || '') === key
    )
  }

  marketSelected (preventRedirect: boolean) {
    if (!this.$store.getters.isAuthenticated) {
      return
    }

    this.$store
      .dispatch(
        this.$route.path.includes('admin')
          ? 'loadProductsAdmin'
          : 'loadProducts',
        this.$store.getters.getSelectedMarket
      )
      .then(() => {
        this.products = this.$store.getters.getProducts
          .filter((p: Product) => !p.disabled)
          .sort((a: Product, b: Product) => {
            return a.name.toLowerCase() < b.name.toLowerCase()
              ? -1
              : a.name.toLowerCase() > b.name.toLowerCase()
                ? 1
                : 0
          })
        this.$store.dispatch(
          'loadResourcesKeysForMarket',
          this.$store.getters.getSelectedMarket
        )
        if (preventRedirect) {
          return
        }
        if (this.$route.path.includes('product')) {
          if (this.$route.path.includes('admin')) {
            // eslint-disable-next-line node/handle-callback-err
            this.$router
              .push({
                name: 'product-admin',
                params: { productKey: this.$route.params.productKey }
              })
              .catch(() => {})
            return
          }
          // eslint-disable-next-line node/handle-callback-err
          this.$router
            .push({
              name: 'product',
              params: { productKey: this.$route.params.productKey }
            })
            .catch(() => {})
        }
      })
  }

  created () {
    this.marketSelected(true)
    EventBus.$on('market-selected', this.marketSelected)

    this.$root.$on('bv::dropdown::hide', () => {
      this.expandedProductKey = null
    })

    this.$root.$on('bv::dropdown::shown', (bvEvent: any) => {
      // Try multiple selectors to find the dropdown menu
      let dropdownMenu = bvEvent.target?.querySelector('.dropdown-menu.show')
      if (!dropdownMenu) {
        dropdownMenu = bvEvent.target?.querySelector('.dropdown-menu')
      }
      if (!dropdownMenu && bvEvent.target?.classList?.contains('dropdown-menu')) {
        dropdownMenu = bvEvent.target
      }

      if (dropdownMenu) {
        // Double RAF to ensure DOM is fully painted after transitions
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.equalizeDropdownWidths(dropdownMenu)
          })
        })
      }
    })
  }
}
